import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://tailorhub-production.up.railway.app/api/v1';
// Export the API origin (protocol + host + port) for building absolute asset URLs (e.g., /uploads/...)
export const API_ORIGIN = (() => {
  try {
    return new URL(API_URL).origin;
  } catch {
    return '';
  }
})();

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000, // Increased to 30 seconds for payment processing
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token invalidation and secure error handling
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 (Unauthorized) and 403 (Forbidden) responses
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear local storage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login page
      window.location.href = '/login';
      
      // Show notification if possible
      if (window.showNotification) {
        window.showNotification('Session expired. Please login again.', 'warning');
      }
    }
    
    // Production-safe error handling - don't expose API details
    if (process.env.NODE_ENV === 'production') {
      // Sanitize error response to prevent API endpoint exposure
      const sanitizedError = {
        ...error,
        config: {
          ...error.config,
          url: error.config?.url ? 'API endpoint' : undefined,
          baseURL: undefined,
        },
        response: error.response ? {
          ...error.response,
          config: {
            ...error.response.config,
            url: error.response.config?.url ? 'API endpoint' : undefined,
            baseURL: undefined,
          }
        } : undefined
      };
      
      return Promise.reject(sanitizedError);
    }
    
    return Promise.reject(error);
  }
);

// Global function to show notifications (can be called from anywhere)
declare global {
  interface Window {
    showNotification: (message: string, severity: 'success' | 'error' | 'warning' | 'info') => void;
  }
}

export default axiosInstance; 